import { NgClass } from '@angular/common';
import { Component, Signal, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IHeaderGroupAngularComp } from 'ag-grid-angular';
import { IHeaderGroupParams } from 'ag-grid-community';

@Component({
  selector: 'grid-engine-group-header-cell',
  templateUrl: './group-header-cell.component.html',
  imports: [NgClass, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./group-header-cell.component.scss']
})
export class GroupHeaderCellComponent implements IHeaderGroupAngularComp {
  params: WritableSignal<IHeaderGroupParams & { skipTextTransform?: boolean }> = signal(null);
  expandState: WritableSignal<string> = signal('');
  showExpandArrow: Signal<boolean> = signal(false);

  agInit(params: IHeaderGroupParams & { skipTextTransform?: boolean }): void {
    this.params.set(params);
    this.params().columnGroup.getProvidedColumnGroup().addEventListener('expandedChanged', this.syncExpandButtons.bind(this));
  }

  expandOrCollapse() {
    const params = this.params();
    const currentState = params.columnGroup.getProvidedColumnGroup().isExpanded();
    params.setExpanded(!currentState);
  }

  syncExpandButtons(): void {
    const params = this.params();
    const expanded = params.columnGroup.getProvidedColumnGroup().isExpanded();
    this.expandState.set(expanded ? 'expanded' : 'collapsed');
  }
}
